// extracted by mini-css-extract-plugin
export default {"hero":"Privacy_hero__OP-yT","intro":"Privacy_intro__yu8E2","content":"Privacy_content__5+PYX","list":"Privacy_list__ThT80","meta":"Privacy_meta__zwhhB"};